import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { businessSelectors } from 'app-components/flux/business';
import type { BusinessColor } from 'app-components/utils/theme';
import { businessColorReadable } from 'app-components/utils/theme';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  colorField: {
    width: '40%',
  },
  infoIcon: {
    color: theme.palette.icon.light,
    marginLeft: 8,
    height: 24,
    width: 24,
  },
}));

type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  currColor: BusinessColor | '';
};

export default function BusinessColorSelect(props: Props) {
  const { onChange, currColor } = props;
  const { classes } = useStyles();

  const theme = useTheme();
  let colorArr: ReadonlyArray<BusinessColor> = useSelector(businessSelectors.getBusinessColors);
  if (!colorArr.find((c) => c === currColor) && currColor !== '' && currColor !== null) {
    colorArr = colorArr.concat(currColor);
  }

  return (
    <>
      <TextField
        id='color-select-element'
        label='Color'
        select
        className={classes.colorField}
        margin='normal'
        variant='filled'
        defaultValue={currColor || ''}
        onChange={onChange}
      >
        {colorArr.map((color) => (
          <MenuItem key={color} value={color} id={color} aria-label={businessColorReadable?.[color] ?? color}>
            <Box display='flex' alignItems='center'>
              <Box
                // @ts-expect-error FIXME TS7053
                bgcolor={theme.palette[color]?.main || theme.palette.background.layer2}
                height={20}
                width={20}
                borderRadius={20}
              />
            </Box>
          </MenuItem>
        ))}
      </TextField>
      <Tooltip title='Color helps identify your business throughout Simplifi.'>
        <InfoIcon className={classes.infoIcon} />
      </Tooltip>
    </>
  );
}
